import { useSyncExternalStore } from "react";
import { useUser } from "@clerk/react";
import { isAuthDisabled } from "@/lib/authMode";
import { isDemoModeActive, subscribeDemoMode } from "@/lib/demoMode";

const DEFAULT_ADMIN_EMAIL = "contact@quad-action.fr";

export function useIsAdmin(): { isLoaded: boolean; isAdmin: boolean } {
  // Reactive demo-mode state — must be called unconditionally (Rules of Hooks).
  const demoActive = useSyncExternalStore(
    subscribeDemoMode,
    isDemoModeActive,
    () => false,
  );

  if (isAuthDisabled()) {
    // Dev / auth-disabled mode: admin UI is visible ONLY when the demo
    // banner is NOT active. Once "Essayer la démo" is clicked the admin
    // tab and the VUE ADMIN impersonation selector are hidden.
    return { isLoaded: true, isAdmin: !demoActive };
  }

  // Production path: Clerk is active — check primary e-mail strictly.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { isLoaded, user } = useUser();
  const adminEmail = (
    (import.meta.env.VITE_ADMIN_EMAIL as string | undefined) ??
    DEFAULT_ADMIN_EMAIL
  ).toLowerCase();
  if (!isLoaded) return { isLoaded: false, isAdmin: false };
  const email = (
    user?.primaryEmailAddress?.emailAddress ?? ""
  ).toLowerCase();
  return { isLoaded: true, isAdmin: !!email && email === adminEmail };
}
